interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  const centered = align === 'center';
  return (
    <div className={centered ? 'max-w-3xl mx-auto text-center' : 'max-w-3xl'}>
      <div className={`flex items-center gap-3 ${centered ? 'justify-center' : ''}`}>
        <span className="h-px w-8 bg-accent-500" aria-hidden="true" />
        <span className="font-label text-xs uppercase tracking-[0.28em] text-primary-600">{eyebrow}</span>
      </div>
      <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">{desc}</p>
      ) : null}
    </div>
  );
}